import { render, staticRenderFns } from "./LotViewDescription.vue?vue&type=template&id=601e38f8&scoped=true&"
import script from "./LotViewDescription.vue?vue&type=script&lang=js&"
export * from "./LotViewDescription.vue?vue&type=script&lang=js&"
import style0 from "./LotViewDescription.vue?vue&type=style&index=0&id=601e38f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601e38f8",
  null
  
)

export default component.exports